<template>
    <div>
        <b-modal
            id="new-product"
            size="lg modal-xlg"
            title="New Product"
            hide-footer
            ref="NewProduct"
            no-close-on-backdrop
            no-close-on-esc
            @show="onShowModal"
        >
            <b-container fluid class="px-0">
                <div class="modal-form">
                    <b-row no-gutters>
                        <b-col class="border-top border-right add-delivery-sidebar bg-white" lg="3">
                            <BasicDetails
                                v-if="branches.length"
                                :values="basic_details"
                                :origin="'new_product'" />

                            <template v-if="basic_details.product_variation == 'variable'">
                                <Variables :values="product_variables"
                                    @addAttribute="addAttribute"
                                    @addVariation="addVariation"
                                    @generateVariations="generateVariations"
                                    @deleteVariation="deleteVariation"
                                    @deleteAttribute="deleteAttribute"
                                    :origin="'new_product'" />
                            </template>
                            <AdOns :values="ad_ons"
                                @addAttributeAdOn="addAttributeAdOn"
                                @addVariationAdOn="addVariationAdOn"
                                @generateVariationsAdOn="generateVariationsAdOn"
                                @deleteVariationAdOn="deleteVariationAdOn"
                                @deleteAttributeAdOn="deleteAttributeAdOn"
                                :origin="'new_product'" />
                            <ProductImages
                                :values="product_images"
                                @removeImage="removeProductImage"
                                :origin="'new_product'" />
                        </b-col>
                        <b-col class="border-top p-0" lg="9">
                            <b-row no-gutters class="border-bottom px-4 py-3" style="background-color: #ffffff;">
                                <b-col></b-col>
                                <b-col cols="2">
                                    <b-button
                                        variant="primary"
                                        v-bind:disabled="loading"
                                        block
                                        class="save-button"
                                        @click="saveProduct">
                                        <template v-if="loading">
                                        SAVING PRODUCT
                                        </template>
                                        <template v-else>
                                            SAVE PRODUCT
                                        </template>
                                    </b-button>
                                </b-col>
                            </b-row>
                            <div class="main">
                                <template v-if="basic_details.product_variation === 'simple'">
                                    <SimpleProduct
                                        :values="simple_product"
                                        :origin="'new_product'"
                                        :payment="payment" />
                                </template>
                                <template v-else>
                                    <ProductVariables
                                        :values="variation_items"
                                        :discount="product_variables.discount"
                                        :origin="'new_product'"
                                        :sale="product_variables.sale"
                                        :payment="payment"
                                        @updateDiscountValue="updateDiscountValue" />
                                </template>
                                <template v-if="ad_on_items.length > 0">
                                    <AdOnItems
                                        :values="ad_on_items"
                                        :discount="ad_ons.discount"
                                        :origin="'new_product'"
                                        :sale="ad_ons.sale"
                                        :payment="payment"
                                        @updateDiscountValue="updateDiscountValue" />
                                </template>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </b-container>
            <template slot="modal-header-close">
                <span @click="closeModal">×</span>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import BasicDetails from "./BasicDetails";
import ProductImages from "./ProductImages";
import SimpleProduct from "./SimpleProduct";
import ProductVariables from "./ProductVariables";
import Variables from "./Variables";
import AdOns from "./AdOns";
import AdOnItems from "./AdOnItems";

function initialProductImages() {
    return [
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false },
        { image: "", active: false }
    ];
}

export default {
    name: "NewProduct",
    props: [
        "status",
        "basic_details",
        "simple_product",
        "product_variables",
        "variation_items",
        "payment",
        "ad_ons",
        "ad_on_items"
    ],
    components: {
        BasicDetails,
        ProductImages,
        SimpleProduct,
        ProductVariables,
        Variables,
        AdOns,
        AdOnItems
    },
    data() {
        return {
            product_images: initialProductImages()
        };
    },
    computed: {
        ...mapState("estoreInventories", [
            "loading",
            "errors",
            "modal",
            "sale"
        ]),
        ...mapState("estoreSettings", ["settings"]),
        ...mapState("analytics", ["isSegmentAnalyticsReady"]),
        ...mapState("branches", ["branches"]),
    },
    methods: {
        ...mapActions({
            getCategories: "estoreInventories/getCategories"
        }),
        async onShowModal() {
            await this.$store.dispatch("branches/getBranches", true);
            this.$root.$emit("clearSelectedBrandsAndBranches");
        },
        closeModal: function() {
            this.$store.commit("estoreInventories/setModal", {
                type: "new_product",
                status: false
            });
            this.setInitialData();
        },
        saveProduct: async function() {
            this.$store.commit("estoreInventories/errors", null);

            let create_images = this.product_images
                .map(image => {
                    return {
                        action: "create",
                        image: image.image.split("base64,").pop()
                    };
                })
                .filter(image => image.image !== "");

            let param = {};
            let basic_details = this.basic_details;

            param["name"] = basic_details.name;
            param["description"] = basic_details.description;
            param["category_id"] = basic_details.category_id;
            param["product_images"] = create_images;
            param["is_limited_stock"] = this.settings.limited_stock;
            let formattedAdOns = [];
            this.ad_ons.attributes.forEach(attribute => {
                let formattedAttribute = {};
                attribute.variations.forEach(variation => {
                    delete variation.action;
                });
                formattedAttribute = {
                    name: attribute.name,
                    limit: attribute.limit,
                    items: attribute.variations
                };
                if (attribute.name != "") {
                    formattedAdOns.push(formattedAttribute);
                }
            });
            param["add_ons"] = formattedAdOns;

            let simple_product = this.simple_product;

            if (simple_product.on_sale) {
                param["discount_type"] = simple_product.discount_type;
                param["discount_value"] = simple_product.discount_value;
                if (
                    this.$parent.isMoment(
                        simple_product.date_range.split(" to ")[0]
                    )
                ) {
                    param["on_sale_from"] =
                        simple_product.date_range.split(" to ")[0] +
                        " 00:00:00";
                } else {
                    param["on_sale_from"] =
                        this.$parent.formatDate(
                            simple_product.date_range.split(" to ")[0]
                        ) + " 00:00:00";
                }
                if (
                    this.$parent.isMoment(
                        simple_product.date_range.split(" to ")[1]
                    )
                ) {
                    param["on_sale_from"] =
                        simple_product.date_range.split(" to ")[1] +
                        " 23:59:59";
                } else {
                    param["on_sale_to"] =
                        this.$parent.formatDate(
                            simple_product.date_range.split(" to ")[1]
                        ) + " 23:59:59";
                }
            }

            param["branch_uuids"] = basic_details.branch_uuids;

            if (this.branches.length === 1)
              param["branch_uuids"] = [this.branches[0].uuid];

            param["selected_all_brands_branches"] =
                basic_details.selected_all_brands_branches;

            if (basic_details.product_variation === "simple") {
                param["on_sale"] = simple_product.on_sale;
                param["visibility"] = simple_product.visibility;
                param["stock"] = simple_product.stock;
                param["currency"] = simple_product.currency;
                param["regular_price"] = simple_product.regular_price;
                param["sku"] = simple_product.sku;
                await this.$store
                    .dispatch("estoreInventories/saveSimpleProduct", param)
                    .then(() => {
                        if (this.errors == null) {
                            this.getCategories();
                            this.closeModal();
                            
                            if (this.isSegmentAnalyticsReady) {
                                param.product_images = !!param.product_images.length;

                                window.analytics.track(
                                    "Create E-Store Simple Product",
                                    param
                                );
                            }

                            this.$store.dispatch(
                                "estoreInventories/getProducts",
                                {
                                    page: 1,
                                    payload: {
                                        filters: {
                                            paired_key: "all",
                                            keyword: "",
                                            column: "all"
                                        }
                                    }
                                }
                            );
                        }
                    });
            } else {
                param["product_variables"] = [];
                param["product_attributes"] = this.product_variables.attributes;
                let variations = this.variation_items;
                param.product_variables = variations.map(variant => {
                    let variationCode = "";
                    let variants = variant.variation.split(" | ");
                    for (let index = 0; index < variants.length; index++) {
                        for (
                            let k = 0;
                            k < param["product_attributes"].length;
                            k++
                        ) {
                            let searchResult = param["product_attributes"][
                                k
                            ].variations.find(
                                paramVariation =>
                                    paramVariation.name === variants[index]
                            );
                            if (typeof searchResult !== "undefined") {
                                variationCode += searchResult.hash + "_";
                            }
                        }
                    }
                    let variable = {
                        action: "create",
                        variable: {
                            variation_code: variationCode
                                .slice(0, -1)
                                .replace(/ /g, ""),
                            stock: variant.stock,
                            currency: variant.currency,
                            visibility: variant.visibility,
                            sku: variant.sku,
                            regular_price: variant.regular_price,
                            on_sale: variant.on_sale,
                            is_limited_stock: this.settings.limited_stock
                        }
                    };
                    if (variant.on_sale == true) {
                        variable.variable["discount_type"] =
                            variant.discount_type;
                        variable.variable["discount_value"] =
                            variant.discount_value;
                        variable.variable[
                            "on_sale_from"
                        ] = this.$parent.isMoment(variant.on_sale_from)
                            ? variant.on_sale_from + " 00:00:00"
                            : this.$parent.formatDate(variant.on_sale_from) +
                              " 00:00:00";
                        variable.variable["on_sale_to"] = this.$parent.isMoment(
                            variant.on_sale_to
                        )
                            ? variant.on_sale_to + " 23:59:59"
                            : this.$parent.formatDate(variant.on_sale_to) +
                              " 23:59:59";
                    }
                    return variable;
                });

                await this.$store
                    .dispatch("estoreInventories/saveVariableProduct", param)
                    .then(() => {
                        if (this.errors == null) {
                            this.getCategories();
                            this.closeModal();
                            
                            if (this.isSegmentAnalyticsReady) {
                                param.product_images = !!param.product_images.length;
                                 
                                window.analytics.track(
                                    "Create E-Store Variable Product",
                                    param
                                );
                            }

                            this.$store.dispatch(
                                "estoreInventories/getProducts",
                                {
                                    page: 1,
                                    payload: {
                                        filters: {
                                            paired_key: "all",
                                            keyword: "",
                                            column: "all"
                                        }
                                    }
                                }
                            );
                        }
                    });
            }
        },
        removeProductImage: async function(index) {
            this.product_images.splice(index, 1);
            this.product_images.push({
                image: "",
                active: false
            });

            let is_images_empty = await this.product_images
                .map(image => {
                    return image;
                })
                .filter(image => image.image == "");

            if (is_images_empty.length == 10) {
                await this.$store.commit(
                    "estoreInventories/setActiveImage",
                    null
                );
            } else {
                await this.$store.commit("estoreInventories/setActiveImage", 0);
            }
        },
        addAttribute: function(attribute) {
            this.$parent.addAttribute(attribute);
        },
        addVariation: function(index) {
            this.$parent.addVariation(index);
        },
        generateVariations: function(origin) {
            this.$parent.generateVariations(origin);
        },
        deleteAttribute: function(index) {
            this.$parent.deleteAttribute(index);
        },
        deleteVariation: function(param) {
            this.$parent.deleteVariation(param);
        },
        addAttributeAdOn: function(attribute) {
            this.$parent.addAttributeAdOn(attribute);
        },
        addVariationAdOn: function(index) {
            this.$parent.addVariationAdOn(index);
        },
        generateVariationsAdOn: function() {
            this.$parent.generateVariationsAdOn();
        },
        deleteAttributeAdOn: function(index) {
            this.$parent.deleteAttributeAdOn(index);
        },
        deleteVariationAdOn: function(param) {
            this.$parent.deleteVariationAdOn(param);
        },
        updateDiscountValue: function(value) {
            this.$parent.updateDiscountValue(value);
        },
        setInitialData: function() {
            this.$parent.setBasicDetailsInit();
            this.$parent.setSimpleProductInit();
            this.$parent.setProductVariablesInit();
            this.$parent.setVariationItemsInit();
            this.$parent.setAdOnsInit();
            this.$parent.setAdOnItemsInit();
            this.product_images = initialProductImages();
        }
    },
    watch: {
        status: function(status) {
            if (status === true) {
                this.$refs.NewProduct.show();
                this.$store.commit("estoreInventories/setActiveImage", null);
                this.$store.commit("estoreInventories/errors", null);
            } else {
                this.$refs.NewProduct.hide();
            }
        },
        "modal.croppa.base64": function(base64) {
            if (base64 !== null) {
                let empty_images = this.product_images
                    .map((image, index) => {
                        return {
                            image: image.image,
                            index: index
                        };
                    })
                    .filter(image => image.image == "");

                let get_index = empty_images[0].index;

                if (this.product_images[0] !== "") {
                    this.$store.commit("estoreInventories/setActiveImage", 0);
                }

                this.product_images[get_index].image = base64;
            }
        }
    }
};
</script>
